import { gpHome } from '../app';
import { ISubscriptionStatus, CurrentUserService } from '../../app-common/services/current-user-service';

export class AccountsService {
    static $inject = ['$http', '$q', CurrentUserService.serviceName];
    private serviceBase = __gameplan_service_url || 'http://localhost/';

    constructor(private readonly $http: ng.IHttpService, private $q: ng.IQService, private readonly currentUserService: CurrentUserService) {
    }

    public confirmEmail(userId: string, code: string): ng.IPromise<any> {
        const deferred = this.$q.defer();

        const httpReq = this.$http.get(this.serviceBase + 'api/accounts/confirmemail', {
                params: {
                    userId: userId,
                    code: code,
                }
            });

        httpReq.then(() => deferred.resolve(true)).catch(err => { });

        httpReq.catch(response => deferred.reject(response));

        return deferred.promise;
    }

    public confirmEmailChange(userId: string, code: string): ng.IPromise<any> {
        const deferred = this.$q.defer();

        const httpReq = this.$http.get(this.serviceBase + 'api/accounts/user/confirm-email-change/' + userId, {
                params: {
                    code: code,
                }
            });

        httpReq.then(() => deferred.resolve(true)).catch(err => { });

        httpReq.catch(response => deferred.reject(response));

        return deferred.promise;
    }

    public confirmEmailCreatePassword(userId: string, code: string, password: string): ng.IPromise<any> {
        const deferred = this.$q.defer();

        const httpReq = this.$http.get(this.serviceBase + 'api/accounts/confirm-and-create-password', {
                params: {
                    userId: userId,
                    code: code,
                    password: password,
                }
            });

        httpReq.then(() => deferred.resolve(true)).catch(err => { });

        httpReq.catch(response => deferred.reject(response));

        return deferred.promise;
    }

    public resendEmail(userId: string): ng.IPromise<any> {
        const deferred = this.$q.defer();

        const httpReq = this.$http.get(this.serviceBase + 'api/accounts/resend-confirmation', {
                params: {
                    userId: userId,
                }
            });

        httpReq.then(() => deferred.resolve(true)).catch(err => { });

        httpReq.catch(response => deferred.reject(response));

        return deferred.promise;
    }

    public getSubscriptionStatus(): ng.IPromise<ISubscriptionStatus> {
        return this.currentUserService.getSubscriptionStatus();
    }

    requestChangePasswordEmail(email: string): ng.IPromise<any> {
        const deferred = this.$q.defer();

        const httpReq = this.$http.get(this.serviceBase + 'api/accounts/request-password-change', {
            params: {
                email: email
            }
        });

        httpReq.then(() => deferred.resolve({})).catch(err => { });
        httpReq.catch(response => deferred.reject(response));

        return deferred.promise;
    }

    changePassword(args: { userId: string; newPassword: string; verificationCode: string }): ng.IPromise<any> {

        const deferred = this.$q.defer();

        const httpReq = this.$http.post(this.serviceBase + 'api/accounts/user/' + args.userId + '/password', {
            userId: args.userId,
            newPassword: args.newPassword,
            verificationCode: args.verificationCode,
        });

        httpReq.then(() => deferred.resolve({})).catch(err => { });
        httpReq.catch(response => deferred.reject(response));

        return deferred.promise;
    }

    setAsNewlyRegisterdUser(email: string, newlyRegistered: boolean): void {

        if (newlyRegistered) {
            localStorage.setItem(`_gp_newly_registered_${email}`, "true");
        } else {
            localStorage.removeItem(`_gp_newly_registered_${email}`);
        }
    }

    isNewlyRegistered(email: string): boolean {
        return localStorage.getItem(`_gp_newly_registered_${email}`) === "true";
    }
}

gpHome.service('accountsService', AccountsService);
